import { render, staticRenderFns } from "./WalletInput.vue?vue&type=template&id=ad514c2e&scoped=true&"
import script from "./WalletInput.vue?vue&type=script&lang=js&"
export * from "./WalletInput.vue?vue&type=script&lang=js&"
import style0 from "./WalletInput.vue?vue&type=style&index=0&id=ad514c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad514c2e",
  null
  
)

export default component.exports